import { render } from "./ClientCreate.vue?vue&type=template&id=f5700dbc"
import script from "./ClientCreate.vue?vue&type=script&lang=js"
export * from "./ClientCreate.vue?vue&type=script&lang=js"

import "../../../src/assets/css/formTab.css?vue&type=style&index=0&lang=css"
import "./ClientCreate.vue?vue&type=style&index=1&id=f5700dbc&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__